const inbox = {
  title: 'Inbox',
  subtitle: 'Read and reply to candidate email across connected mailboxes',
  sync: 'Sync mail',
  refresh: 'Refresh list',
  threadCount: '{shown}/{total} loaded',
  loadMore: 'Load more',
  connect: 'Connect inbox',
  folders: 'Folders',
  allMailboxes: 'All mailboxes',
  mailboxes: 'Mailboxes',
  unread: 'Unread only',
  search: 'Search subject or message',
  clearSearch: 'Clear search',
  retry: 'Try again',
  loadFailed: 'Could not load inbox',
  statusUpdateFailed: 'Could not update the read status',
  emptyTitle: 'No messages yet',
  emptyHint: 'New messages will appear here after a sync',
  connectHint: 'Connect a mailbox to start receiving mail',
  selectConversation: 'Select a message to view the conversation',
  noSubject: 'No subject',
  campaign: 'Cold email campaign',
  reply: 'Reply',
  replyPlaceholder: 'Write a reply…',
  replyFrom: 'Replying from {email}',
  sendReply: 'Send reply',
  markRead: 'Mark read',
  markUnread: 'Mark unread',
  markReadSuccess: 'Marked as read',
  markUnreadSuccess: 'Marked as unread',
  markAllRead: 'Mark all as read',
  markAllReadSuccess: 'All marked as read',
  connectTitle: 'Connect inbox',
  connectDescription: 'Choose an existing sender account and enable incoming mail sync',
  senderAccount: 'Email account',
  selectAccount: 'Select an account',
  provider: 'Incoming mail provider',
  gmailProviderHint: 'Gmail API is available only for accounts connected with Google OAuth.',
  imapHost: 'IMAP server',
  imapPort: 'IMAP port',
  useSsl: 'Use SSL/TLS',
  gmailReauthorizeHint:
    'Gmail needs additional read access when Inbox is enabled. Reauthorize the account in Email Settings if sync reports insufficient permissions.',
  syncing: 'Syncing…',
  syncFailureBadge: 'Sync failed',
  syncFailureConnection: 'Sync failed: could not connect to the mail service',
  syncFailureAuth: 'Sync failed: check your credentials or reauthorize',
  syncFailureUnknown: 'Sync failed. Check mailbox settings',
  syncFailureRetrying: 'Retrying…',
  syncFailureRetry: 'Retry sync',
  syncFailureSettings: 'Mailbox settings',
  syncComplete: 'Mailbox sync complete',
  syncFailed: 'Sync failed for {count} mailbox(es). Check the account settings and try again.',
  connectFailed: 'Could not connect this mailbox. Check the account settings and try again.',
  deleteAccount: 'Disconnect',
  deleteAccountTitle: 'Disconnect Mailbox',
  deleteAccountDescription: 'Are you sure you want to disconnect {email}? New messages will no longer be synced.',
  deleteAccountSuccess: 'Mailbox disconnected successfully',
  deleteAccountFailed: 'Failed to disconnect mailbox. Please try again.',
  replySent: 'Reply sent',
  replyFailed: 'Could not send the reply. Check the outgoing mail settings and try again.',
  sendShortcutHint: 'Send (Ctrl + Enter)',
  editor: {
    bold: 'Bold (Ctrl+B)',
    italic: 'Italic (Ctrl+I)',
    underline: 'Underline (Ctrl+U)',
    orderedList: 'Numbered list',
    bulletList: 'Bulleted list',
    link: 'Insert link',
    clean: 'Clear formatting',
  },
  tabAll: 'All',
  tabUnread: 'Unread',
  tabWait: 'Waiting',
  newMail: 'New Email',
  hideInfo: 'Collapse sidebar',
  showInfo: 'Expand sidebar',
  delivered: 'Delivered',
  aiSuggestReply: 'Suggest reply',
  aiSuggestSchedule: 'Schedule interview',
  from: 'From',
  to: 'To',
  viewCandidate: 'View candidate',
  candidate: 'Candidate',
  candidateLocation: 'Location',
  candidateExperience: 'Experience',
  candidateEducation: 'Education',
  experienceYears: '{years} years',
  timeline: 'Activity timeline',
  latestMessage: 'Latest activity',
  firstMessage: 'First contact',
  notes: 'Team notes',
  notesPlaceholder: 'Add notes about this candidate (visible to team only)…',
  folder: { all: 'All mail', inbox: 'Inbox', sent: 'Sent', archive: 'Archive', unarchive: 'Unarchive', drafts: 'Drafts', junk: 'Junk', trash: 'Trash' },
  status: {
    pending: 'Waiting for first sync',
    syncing: 'Syncing',
    ready: 'Up to date',
    error: 'Sync error',
  },
  addToJob: 'Add to Job',
  addToJobPending: 'Adding to job is not yet supported',
  viewCandidateDetails: 'View Candidate',
  linkedJob: 'Linked Job',
  noLinkedJob: 'No linked job',
  talentPoolTags: 'Talent Pool Tags',
  noTags: 'No tags',
  currentJobStatus: 'Current Job Status',
  recentActivity: 'Recent Activity',
  reauthorize: 'Reauthorize',
  reauthorizeRequired: 'Reauthorization required',
  candidateResumeFailed: 'Unable to load candidate resume',
  archiveSuccess: 'Archived successfully',
  archiveFailed: 'Failed to archive',
  unarchiveSuccess: 'Unarchived successfully',
  unarchiveFailed: 'Failed to unarchive',
  stageUpdateSuccess: 'Candidate stage updated successfully',
  stageUpdateFailed: 'Failed to update candidate stage',
  tabWaitHint: 'Filtering by waiting is not yet supported by backend, showing all',
  reauthorizeSuccess: 'Reauthorized successfully',
  reauthorizeFailed: 'Reauthorization failed',
  reauthorizeSaveFailed: 'Failed to save reauthorization',
  connectFirst: 'Please connect an email account first',
  recipientAndSubjectRequired: 'Recipient and subject are required',
  sendSuccess: 'Sent successfully',
  sendFailed: 'Failed to send',
  moreActionsPending: 'More actions not yet supported (waiting for backend API)',
  downloadAttachmentFailed: 'Failed to download attachment',
  emailTemplates: 'Email Templates',
  scheduleSend: 'Scheduled Send',
  scheduleSendPending: 'Scheduled send is not yet supported',
  insertTemplateTitle: 'Insert Email Template',
  selectTemplatePlaceholder: 'Select an email template',
  insert: 'Insert',
  getTemplatesFailed: 'Failed to get email templates',
  linkPlaceholder: 'Enter or paste link (e.g. https://...)',
  subject: 'Subject',
  subjectPlaceholder: 'Email subject',
  toPlaceholder: 'Enter email addresses, separated by commas',
}

export default inbox
